import { render } from "./SendCalculation.vue?vue&type=template&id=35f0314a"
import script from "./SendCalculation.vue?vue&type=script&lang=js"
export * from "./SendCalculation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__